import { useAuth0 } from "@auth0/auth0-react";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import { TableCell } from "@material-ui/core";
import TableRow from "@material-ui/core/TableRow";
import PreSchoolService from "Lib/API/PreSchool";
import Action from "components/ActionPopOver";
import { CheckBox } from "components/CheckBox/CheckBox";
import AlertDialog from "components/Dialog";
import Loader from "components/loader/Loader";
import { formatDate } from "helper/dateFormat";
import { numberFormat } from "helper/numberFormat";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";
import { Status } from "./Theme";
import "./index.scss";
import { useApiAction } from "hook/useFetchData";
import { useParams } from "react-router-dom";

const ParticipantDetailsTableBody = ({
  setOpenDrawer,
  setDrawerData,
  rows,
  loading,
  formId,
  refresh,
  setRefresh,
  onSharePaymentLinkClick,
  onCheckboxChange,
  check,
  checkAll,
}) => {
  const { id } = useParams();
  const history = useHistory();
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [paymentLinkId, setPaymentLinkId] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [moveParticipantId, setMoveParticipantId] = useState(null);
  const [classMovedId, setClassMovedId] = useState(null);
  const [currentRow, setCurrentRow] = useState(null);
  const [inviteResent, setInviteResent] = useState(false);
  const formName = useSelector((state) => state.forms.formName);
  const { getAccessTokenSilently } = useAuth0();

  const { execute: reSentInvitation, loading: reSentLoading } = useApiAction(
    (token, body) => PreSchoolService.resendFormInvitation(token, body)
  );

  const getStatusMessage = (newStatus, currentRow) => {
    if (
      currentRow?.registrationStatus === "pending" &&
      newStatus === "approved"
    ) {
      return `You are about to admit ${currentRow?.firstName} ${currentRow?.lastName} into  Form ${formName}, please confirm`;
    }
    if (
      currentRow?.registrationStatus === "pending" &&
      newStatus === "not-approve"
    ) {
      return `You are about to deny ${currentRow?.firstName} ${currentRow?.lastName} into  Form ${formName}, please confirm`;
    }
    if (
      currentRow?.registrationStatus === "pending" &&
      newStatus === "on-hold"
    ) {
      return "";
    }
    if (
      currentRow?.registrationStatus === "approved" &&
      newStatus === "not-approve"
    ) {
      return `You are about to deny ${currentRow?.firstName} ${currentRow?.lastName} from Form ${formName}, please confirm`;
    }
    if (
      currentRow?.registrationStatus === "not-approve" &&
      newStatus === "approved"
    ) {
      return `You are about to admit ${currentRow?.firstName} ${currentRow?.lastName} into Form ${formName}, please confirm`;
    }
    return "";
  };

  const getDeleteMessage = (currentRow) => {
    if (currentRow?.registrationStatus === "pending") {
      return `You are about to delete ${currentRow?.firstName} ${currentRow?.lastName} from Form ${formName}, please confirm`;
    }
    if (currentRow?.registrationStatus === "approved") {
      return `You are about to delete ${currentRow?.firstName} ${currentRow?.lastName} from Form ${formName}, please confirm`;
    }
    if (currentRow?.registrationStatus === "not-approve") {
      return `You are about to delete ${currentRow?.firstName} ${currentRow?.lastName} from Form ${formName}, please confirm`;
    }
    if (currentRow?.registrationStatus === "on-hold") {
      return `You are about to delete ${currentRow?.firstName} ${currentRow?.lastName} from Form ${formName}, please confirm`;
    }
    return "";
  };
  const deleteFormParticipant = async (id) => {
    try {
      setConfirmLoading(true);
      const token = await getAccessTokenSilently();
      const result = await PreSchoolService.deleteFormMemberById(token, id);
      toastr.success("Success", "Participant deleted successfully");
      setRefresh(!refresh);
    } catch (error) {
      toastr.error("Error", error?.data?.message || "Something went wrong");
    } finally {
      setDeleteId(null);
      setConfirmDialog(false);
      setConfirmLoading(false);
    }
  };
  const changeStatus = async (status) => {
    const payload = {
      formId,
      participantId: status?.id,
      status: status?.value,
    };
    try {
      setConfirmLoading(true);
      const token = await getAccessTokenSilently();
      const result = await PreSchoolService.changeStatusParticipant(
        token,
        payload
      );
      toastr.success(
        "Success",
        result?.result?.message || "Participant status updated successfully"
      );
      setRefresh(!refresh);
    } catch (error) {
      toastr.error("Error", error?.data?.message || "Something went wrong");
    } finally {
      setSelectedStatus(null);
      setConfirmDialog(false);
      setCurrentRow(null);
      setConfirmLoading(false);
    }
  };

  const sendPaymentLink = async (id) => {
    const payload = {
      participantId: id,
    };
    try {
      setConfirmLoading(true);
      const token = await getAccessTokenSilently();
      const result = await PreSchoolService.sendPaymentLink(token, payload);
      toastr.success(
        "Success",
        result?.result?.message || "Payment link sent successfully"
      );
      setRefresh(!refresh);
    } catch (error) {
      toastr.error("Error", error?.data?.message || "Something went wrong");
    } finally {
      setPaymentLinkId(null);
      setConfirmDialog(false);
      setConfirmLoading(false);
    }
  };

  const moveParticipantToAnotherClass = async () => {
    const payload = {
      newClass: classMovedId,
      participantId: moveParticipantId,
    };
    try {
      setConfirmLoading(true);
      const token = await getAccessTokenSilently();
      const result = await PreSchoolService.moveParticipant(token, payload);
      toastr.success(
        "Success",
        result?.result?.message || "Participant moved successfully"
      );
    } catch (error) {
      toastr.error("Error", error?.data?.message || "Something went wrong");
    } finally {
      setMoveParticipantId(null);
      setClassMovedId(null);
      setConfirmDialog(false);
      setConfirmLoading(false);
      setRefresh(!refresh);
    }
  };

  return (
    <>
      {loading ? (
        <TableRow>
          <TableCell colSpan={8} align="center">
            <div className="user__loader" style={{ height: "320px" }}>
              <Loader />
            </div>
          </TableCell>
        </TableRow>
      ) : rows?.length === 0 ? (
        <TableRow>
          <TableCell colSpan={8} align="center">
            <h6>No Membership Details Found</h6>
          </TableCell>
        </TableRow>
      ) : (
        rows?.map((row) => (
          <TableRow>
            <TableCell align="left">
              <CheckBox
                onChange={(e) => onCheckboxChange(e, row)}
                checked={
                  checkAll ? true : check.find((obj) => obj._id === row?._id)
                }
                text={""}
                isDisabled={checkAll}
                style={{ marginLeft: 4 }}
              />
            </TableCell>
            <TableCell
              className="charged-value"
              align="left"
              onClick={(e) => {
                e.stopPropagation();
                history.push(`/member-details/${row?.contact?.account_id}`);
              }}
              style={{ cursor: "pointer" }}
            >
              <div className="participant__name">
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  <div
                    className="participant__name-text"
                    style={{ color: "#2455ef", fontWeight: "bold" }}
                  >
                    {row?.accountName}
                  </div>
                  {row?.contact?.account_id && (
                    <a
                      href={`/member-details/${row?.contact?.account_id}`}
                      target="_blank"
                      rel="noreferrer"
                      onClick={(e) => e.stopPropagation()}
                      style={{ display: "flex", alignItems: "center", color: "#2555EF", flexShrink: 0 }}
                    >
                      <OpenInNewOutlinedIcon style={{ fontSize: 10, width: 18, height: 18 }} />
                    </a>
                  )}
                </div>
              </div>
            </TableCell>
            <TableCell
              className="charged-value"
              align="left"
              onClick={() => {
                setDrawerData(row);
                setOpenDrawer(true);
              }}
              style={{ cursor: "pointer" }}
            >
              <div className="participant__name">
                <div className="participant__name-text">{row?.firstName}</div>
              </div>
            </TableCell>
            <TableCell
              className="charged-value"
              align="left"
              onClick={() => {
                setDrawerData(row);
                setOpenDrawer(true);
              }}
            >
              {row?.lastName}
            </TableCell>
            <TableCell
              className="charged-value"
              align="left"
              onClick={() => {
                setDrawerData(row);
                setOpenDrawer(true);
              }}
            >
              {row?.sentTo || "-"}
            </TableCell>
            <TableCell
              className="charged-value"
              align="left"
              onClick={() => {
                setDrawerData(row);
                setOpenDrawer(true);
              }}
            >
              {row?.submitDate
                ? formatDate({
                    date: row?.submitDate,
                    formatType: "defaultWithUTC",
                  })
                : "-"}
            </TableCell>
            <TableCell className="payment__status" align="left">
              <div style={{ display: "flex", alignItems: "center" }}>
                <Status type={row?.status}>{row?.status || "pending"}</Status>
                <div style={{ marginLeft: "10px" }}>
                  {row?.status === "sent" && row?.sendDate
                    ? formatDate({
                        date: row?.sendDate,
                        formatType: "defaultWithUTC",
                      })
                    : ""}
                </div>
              </div>
            </TableCell>

            <TableCell
              className="charged-value"
              align="left"
              onClick={() => {
                setDrawerData(row);
                setOpenDrawer(true);
              }}
            >
              {numberFormat({
                number: +row?.totalPaid,
                decimal: 2,
                style: "currency",
              })}
            </TableCell>
            <TableCell className="sticky-body-column">
              <div
                style={{
                  cursor: "pointer",
                  paddingleft: "0px",
                }}
              >
                <Action
                  action="participant"
                  style={{
                    minHeight: "30px",
                    paddingBottom: "10px",
                  }}
                  onViewClick={() => {
                    setDrawerData(row);
                    setOpenDrawer(true);
                  }}
                  onParticipantDeleteClick={
                    row?.status?.toLowerCase() === "sent"
                      ? () => {
                          setCurrentRow(row);
                          setDeleteId(row._id);
                          setConfirmDialog(true);
                        }
                      : undefined
                  }
                  setClassMovedId={setClassMovedId}
                  setConfirmDialog={setConfirmDialog}
                  sentInvitation={
                    row?.status?.toLowerCase() === "sent"
                      ? () => setInviteResent(row)
                      : undefined
                  }
                />
              </div>
            </TableCell>
          </TableRow>
        ))
      )}
      <AlertDialog
        open={confirmDialog}
        onDecline={() => {
          setDeleteId(null);
          setPaymentLinkId(null);
          setSelectedStatus(null);
          setCurrentRow(null);
          setConfirmDialog(false);
        }}
        onAccept={() => {
          if (deleteId) {
            deleteFormParticipant(deleteId);
          }
          if (selectedStatus?.id) {
            changeStatus(selectedStatus);
          }
          if (paymentLinkId) {
            sendPaymentLink(paymentLinkId);
          }
          if (moveParticipantId && classMovedId) {
            moveParticipantToAnotherClass();
          }
        }}
        title={"Are you sure?"}
        description={
          selectedStatus?.id
            ? getStatusMessage(selectedStatus?.value, currentRow)
            : deleteId
            ? getDeleteMessage(currentRow)
            : ""
        }
        disabled={confirmLoading}
      />
      <AlertDialog
        open={!!inviteResent}
        onDecline={() => setInviteResent(false)}
        onAccept={async () => {
          try {
            await reSentInvitation({
              participantsIds: [inviteResent?._id],
              formId: id,
            });
            setInviteResent(false);
          } catch (error) {
            //
          }
        }}
        title={"Are you sure?"}
        description={"You are about to resend the invitation. Please confirm."}
        disabled={reSentLoading}
      />
    </>
  );
};

export default ParticipantDetailsTableBody;
